const assets = require('../../data/assets.json')

let LoaderMixin = {
	methods: {

		findAssets(target) {
            
            let assetsToLoad = []

            if (target) {

                if (target.name.includes('projects_component')) {
                    assetsToLoad = assetsToLoad.concat(assets['default'])
                }
                else if (target.name === 'about_component') {
                    assetsToLoad = assetsToLoad.concat(assets['about'])                    
                }
                else if (target.name === 'project_component') {
                    
                    if (this.app.isMobile) {
                        var device = "mobile"
                    } else {
                        var device = "desktop"
                    }
                    let assetsPath = assets['projects'][target['params']['projectId']][device]
                    assetsToLoad = assetsToLoad.concat(assetsPath)
                }
                
            } else {
                
                assetsToLoad = assetsToLoad.concat(assets['default'])

                if (this.$route.name.includes('project_component')) {
                    let target = this.$route.params.projectId
                    if (assets['projects'][target] !== undefined) {
                        
                        if (this.app.isMobile) {
                            var device = "mobile"
                        } else {
                            var device = "desktop"
                        }
                        let assetsPath = assets['projects'][target][device]
                        assetsToLoad = assetsToLoad.concat(assetsPath)
                    }
                }
                else if (this.$route.name === 'about_component') {
                    let assetsPath = assets['about']
                    assetsToLoad = assetsPath
                }
                else if (target !== undefined && assets['projects'][target] !== undefined) {
                    let assetsPath = assets['projects'][target]
                    assetsToLoad = assetsToLoad.concat(assetsPath)
                }
            }
            
            return assetsToLoad
		},
        
        loadContent(self, assetsLoader, target, next, app, loader) {
            if (typeof loader === 'undefined') {                
                var loader = self.$parent.$refs.appbase.$refs.loader            
            }

            // on récupère les assets de la cible
            let assetsToLoad = this.findAssets(target)
            assetsLoader.add(assetsToLoad);

            // on rend le loader visible
            loader.isLoading = true
            loader.percentLoaded = 0
            loader.loaderVisible = true
            loader.LoadAnimationAdd();
            
            // le loader charge
            assetsLoader.on('progress', progress=>{
                var percent = Math.round(progress*100)
                loader.loaderWidth < percent ? loader.loaderWidth = percent : undefined
                loader.percentLoaded < percent ? loader.percentLoaded = percent : undefined
            })
            // on va à la page suivante, cache le loader et le réinitialise à 0
            assetsLoader.on('complete', assets=>{
                var self = this
                next()
                
                setTimeout(function () {
                    if (self.$route.name !== 'projects_component' && !self.app.isMobile) {
                        self.app.launchSmoothScroll()
                    }
                    
                    loader.isLoading = false
                    loader.LoadAnimationRemove();
                    loader.loaderWidth = 0
                    loader.loaderVisible = false
                }, 700)
            })
            
            // on attend que le loader soit visible avant de le faire charger
            setTimeout(function () {
                assetsLoader.start()
                
                // permet d'éviter des bugs avec les boutons d'historique du navigateur
                if (target.path.includes('/fr')) {
                    self.$translate.setLang('fr')
                    self.$parent.$refs.appbase.isEng = false
                } else {
                    self.$translate.setLang('en')
                    self.$parent.$refs.appbase.isEng = true
                }
                self.$parent.$refs.appbase.setLinksPath()
            }, 700)
        }

	}
}

export default LoaderMixin



// WEBPACK FOOTER //
// ./src/components/Loader/LoaderMixin.js